import {
  CUSTOMER_SERVICE_PHONE_NUMBER,
  HELP_CENTRE_LOCALISED_URL,
} from '@seek/shared-constants';
import { type Language, siteNames } from '@seek/melways-sites';
import type { EmployerSiteNames } from '../siteConfig';

export const getHelpCentreUrlFromSite = (
  site: EmployerSiteNames = siteNames.employer.seek.au,
  language: Language = 'en',
): string => {
  const siteMapping = HELP_CENTRE_LOCALISED_URL[site];
  return (
    HELP_CENTRE_LOCALISED_URL[site][language as keyof typeof siteMapping] ||
    HELP_CENTRE_LOCALISED_URL[site].en
  );
};

export const getAnzCsPhoneNumberFromSite = (site: EmployerSiteNames) => {
  if (site === siteNames.employer.seek.nz) {
    return CUSTOMER_SERVICE_PHONE_NUMBER[siteNames.employer.seek.nz];
  }
  // default to AU phone number
  return CUSTOMER_SERVICE_PHONE_NUMBER[siteNames.employer.seek.au];
};
